module.exports = __webpack_public_path__ + "static/media/ru.8b2aa18f.svg";